import { useMemo } from "react";
export function useUrl(url) {
    return useMemo(() => typeof url === "string" ? url : URL.createObjectURL(url), [url]);
}
